import React, { useContext } from "react"
import { QuizContext } from "../../App";

const TextQuizHeader = () => {

  const quizContext = useContext(QuizContext);
  const theme = quizContext.state.theme;

  const tasks = quizContext.state.numOfTasks === 11
    || quizContext.state.numOfTasks === 12
    || quizContext.state.numOfTasks === 13
    || quizContext.state.numOfTasks === 14
    ? quizContext.state.numOfTasks
    : Number(quizContext.state.numOfTasks.toString().split("").pop());
  const word = tasks === 1
    ? "задание"
    : tasks === 2 || tasks === 3 || tasks === 4
      ? "задания"
      : "заданий";

  return (
    <>
      <h2 className="header"><span className="header-tq">КВИЗ: </span>

        {quizContext.state.quiz.id === undefined
          ? <><span className="header-tq-title">
            {quizContext.state.quizTitle}
          </span><br /></>
          : quizContext.state.quiz.id !== undefined
            && (quizContext.state.quizStatus === "initial"
              || quizContext.state.quizStatus === "quiz")
            ? <><span className="header-tq-title">
              {quizContext.state.quiz.title}
            </span><br /></>
            : <><span
              className="header-tq-title"
              style={{
                color: theme === "dark"
                  ? "#4da2f7"
                  : "#0a70d6",
                cursor: "pointer"
              }}
              onClick={() => quizContext.dispatch({
                type: "backToQuizTitlePage"
              })}
            >
              {quizContext.state.quiz.title}
            </span><br /></>
        }
        <span className="header-tq">{quizContext.state.numOfTasks} {word}</span>
      </h2>
    </>
  )
}

export default TextQuizHeader